import React from "react";
import { Modal, Button } from "react-bootstrap";
import cross from "../../../assets/images/cross.svg";
import tradeBellPng from "../../../assets/images/bellIcon.svg";
import BubbleSvgButton from "../CommonComponents/BubbleSvgButton/BubbleSvgButton";
import "../NewCopyTrade/ExchangeConnection/ExchangeConnection.css";

export default function SubscriptionConfirmModal({
  show,
  onClose,
  title,
  subtext,
  alert,
  onConfirm,
  confirmText = "Yes",
  onCancel,
  cancelText = "No",
  showCancel = true,
  isLoading = false,
}) {
  return (
    <Modal backdrop="false" id="verificationApiModal" show={show}>
      <Modal.Body>
        <div className="modalContent">
          {!isLoading && (
            <Button className="closeBtn" onClick={onClose}>
              <img alt="Close Modal" src={cross} />
            </Button>
          )}

          {isLoading ? (
            <div className="regBox loadingWrap">
              <div className="loading-4">
                <span className="span1"></span>
                <span className="span2"></span>
                <span className="span3"></span>
              </div>
            </div>
          ) : (
            <>
              <div className="regBox" style={{ gap: "13px" }}>
                <div className="img-box">
                  <img alt="Confirmation" src={tradeBellPng} className="bellIconSvg" />
                </div>
                <div className="content-box">
                  <p className="popUpMsg">
                    {title}
                    <br />
                    <span>{subtext}</span>
                    {alert ? (
                      <>
                        <br />
                        <span className="popUpAlert">{alert}</span>
                      </>
                    ) : null}
                  </p>
                </div>
              </div>
              <div className="payoutButtonBox">
                {onConfirm && (
                  <BubbleSvgButton
                    className="payoutModalBtn"
                    mainDivStyle={{ width: "126px", height: "36px" }}
                    text={confirmText}
                    type="button"
                    variant="black"
                    containerStyling={{ justifyContent: "center" }}
                    onClick={onConfirm}
                  />
                )}
                {showCancel && (
                  <BubbleSvgButton
                    className="payoutModalBtn"
                    mainDivStyle={{ width: "126px", height: "36px" }}
                    text={cancelText}
                    type="button"
                    variant="red"
                    containerStyling={{ justifyContent: "center" }}
                    onClick={onCancel || onClose}
                  />
                )}
              </div>
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}
